import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CompanyDetails as CompanyDetailsType, Detail, State } from 'store/admins/types';
import { addAdmin } from 'store/admins/actions';
import CompanyDetailsForm from 'components/Admins/CompanyDetailsForm';
import apiClient from 'apiClient';
import { admins } from 'routes/routePaths';

const CompanyDetails: React.FC<RouteComponentProps> = ({ history }: RouteComponentProps) => {
  const { strategy }: State = useSelector((state: any) => state.adminsReducer);
  const [adminTypeData, setAdminTypeData] = useState<Array<{ label: string; value: string }>>([]);
  const [companyType, setCompanyType] = useState<string>('');
  const [error, setError] = useState<string>('');
  const dispatch = useDispatch();

  useEffect(() => {
    let shouldCancel = false;

    const fetchAndSetAdminTypeData = async () => {
      try {
        if (strategy && !shouldCancel) {
          const details: Detail[] = await apiClient
            .get(strategy.getDataEndpoint())
            .then((res) => {
              setCompanyType(res.data.company_type);
              return strategy.getDetails(res.data);
            })
            .catch(() => {
              setCompanyType('CLUB');
              return strategy.getDetails({ company_name: 'Company name' });
            });

          setAdminTypeData(details);
        } else {
          throw new Error('Error during creating form.');
        }
      } catch (error) {
        if (!shouldCancel) setError(error.message);
      }
    };

    fetchAndSetAdminTypeData();

    return () => {
      shouldCancel = true;
    };
  }, [dispatch, strategy]);

  const handleSubmit = async (values: CompanyDetailsType) => {
    if (strategy) {
      try {
        await dispatch(addAdmin(strategy.mapDataForSave(values)));
        history.push(admins.list);
      } catch (error) {
        setError(error);
      }
    }
  };

  return (
    <>
      <CompanyDetailsForm
        onSubmit={handleSubmit}
        error={error}
        companyType={companyType}
        details={adminTypeData}
        onBack={history.goBack}
      />
    </>
  );
};

export default CompanyDetails;
